import React from 'react';
import ErrorDescription from '../../../components/marketing/pageSections/error/ErrorDescription';

function Home(props) {
    return (
        <>
            <ErrorDescription />
        </>
    );
}

export default Home;